<template>
  <li class="result-item" v-bind:class="{'result-item__active': isActive}">
    <router-link :to="{
      name: 'Address',
      params: { geohash: this.result.geohash, slug: this.result.slug }
    }">
      {{result.name}}
    </router-link>
  </li>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["result", "isActive"]
};
</script>

<style lang="scss" scoped>
  @import "../../assets/variables";

  .result-item__active {
    background-color: rgba($brand-primary, 0.5);

    a {
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchResults/ResultItem.vue